import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Dialog from '../../common/components/Dialog';
import SentEmails from '../reports/sentEmails';

/**
 * The emails sent about one subscription (confirmation, cancellation, end, reminders). Viewing an email swaps the list for its
 * content rather than opening a second dialog on top of this one.
 */
class SubscriptionEmailsDialog extends Component {
	constructor(props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
			message: null
		};
	}

	handleClose() {
		this.setState({ message: null });
		this.props.onCancel();
	}

	renderBody() {
		const { subscriptionContractId, t } = this.props;
		const { message } = this.state;

		if (message) {
			return <div>
				<Button onClick={() => this.setState({ message: null })} style={{ marginBottom: '15px' }}>
					<FontAwesomeIcon icon={faArrowLeft} /> {t('Common_BackToList')}
				</Button>
				<div dangerouslySetInnerHTML={{ __html: message }} />
			</div>;
		}

		return <SentEmails subscriptionContractId={subscriptionContractId} embedded onShowMessage={text => this.setState({ message: text })} />;
	}

	render() {
		const { show, t } = this.props;
		const config = {
			header: t('PaymentHistory_Subscription_StatutoryEmails'),
			body: this.renderBody(),
			onHide: this.handleClose
		};
		return <Dialog config={config} show={show} t={t} bsSize='large' />;
	}
}

SubscriptionEmailsDialog.propTypes = {
	show: PropTypes.bool,
	subscriptionContractId: PropTypes.number.isRequired,
	onCancel: PropTypes.func.isRequired
};

export default withTranslation()(SubscriptionEmailsDialog);
